import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { getExpertAccessPath, hasApprovedExpertAccess } from "@/lib/expertAccess";
import { PageSkeleton } from "@/components/LoadingSkeleton";

export default function ProtectedRoute({ children, roles, allowUnapprovedExpert = false }) {
  const { user, ready } = useAuth();
  if (!ready) return <PageSkeleton cards={3}/>;
  if (!user) return <Navigate to="/log-ind" replace />;
  if (user.email_verification_required && !user.email_verified_at) return <Navigate to="/bekraeft-email?sendt=1" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  if (
    user.role === "expert" &&
    !allowUnapprovedExpert &&
    !hasApprovedExpertAccess(user)
  ) {
    return <Navigate to={getExpertAccessPath(user)} replace />;
  }
  return children;
}
